module.exports = __webpack_public_path__ + "media/images/pic/courses/intensity-beginner-ae189bd5405ad38c15697a2c4d2a488c.svg";